export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-background-200 py-12">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <a href="#top" className="flex items-center gap-2">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-emotion-laugh-line text-xl" />
              </span>
              <span className="font-heading text-xl text-foreground-950">
                香蕉漫画
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              香蕉漫画APP支持离线阅读、智能缓存、订阅收藏与多端同步，电脑版、
              手机版一应俱全，陪你随时随地畅读精彩漫画。
            </p>
          </div>

          <nav aria-label="快速导航">
            <h3 className="text-sm font-semibold text-foreground-950">快速导航</h3>
            <ul className="mt-4 space-y-2.5">
              {[
                { href: "#features", label: "核心功能" },
                { href: "#categories", label: "漫画分类" },
                { href: "#popular", label: "热门推荐" },
                { href: "#faq", label: "常见问题" },
              ].map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-700"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h3 className="text-sm font-semibold text-foreground-950">联系我们</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              <li>
                <a
                  href="mailto:support@bananacomics.example.com"
                  className="inline-flex items-center gap-2 transition-colors hover:text-primary-700"
                >
                  <i className="ri-mail-line" />
                  support@bananacomics.example.com
                </a>
              </li>
              <li className="inline-flex items-center gap-2">
                <i className="ri-customer-service-2-line" />
                客服时间：每日 9:00 - 21:00
              </li>
              <li className="inline-flex items-center gap-2">
                <i className="ri-bank-card-line" />
                支持 iOS / Android / 电脑版
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-300 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-600">
            © {year} 香蕉漫画网 版权所有
          </p>
          <div className="flex items-center gap-3 text-foreground-600">
            <a
              href="#top"
              aria-label="返回顶部"
              className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50"
            >
              <i className="ri-arrow-up-line" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}